import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/toPromise';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";

@Injectable()
export class AdminService {

	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	getUserStats(model: BaseGraphQueryModel): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/admin/dashboard/user`,model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getContentStats(model: BaseGraphQueryModel): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/admin/dashboard/content`,model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getAssessmentStats(model: DirectoryFilterModel): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/admin/dashboard/assessments`,model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getMarketPlaceStats(model: BaseGraphQueryModel): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/admin/dashboard/marketplace`,model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDashModel(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/admin/dashboard`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getEventsStats(model: BaseGraphQueryModel): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/admin/dashboard/events`,model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getSalesStats(model: BaseGraphQueryModel): Promise<any> {
        return this.http.post(`${this.auth.apiUrl}/api/admin/dashboard/sales`, model, { headers: this.auth.header })
		    .toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	downloadFile(fileName: string): Observable<Blob> {
		const options = { headers: this.auth.header, reportProgress: true, responseType: 'blob' as 'blob' };
		return this.http.get(`${this.auth.apiUrl}/api/admin/${fileName}`, options);
	}
	
	getInvoiceStats(model: BaseGraphQueryModel) {
		return this.http.post(`${this.auth.apiUrl}/api/admin/get/invoice/overall/stats`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getTeamStats(model: BaseGraphQueryModel) {
		return this.http.post(`${this.auth.apiUrl}/api/admin/get/team/overall/stats`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getNoteStats(model: BaseGraphQueryModel) {
		return this.http.post(`${this.auth.apiUrl}/api/admin/get/note/overall/stats`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	
	getRewardStats(model: BaseGraphQueryModel) {
		return this.http.post(`${this.auth.apiUrl}/api/admin/get/reward/overall/stats`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getLoanStats(model: BaseGraphQueryModel) {
		return this.http.post(`${this.auth.apiUrl}/api/admin/get/loan/overall/stats`, model, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getToDoStats(model: BaseGraphQueryModel) {
		return this.http.post(`${this.auth.apiUrl}/api/admin/get/todo/overall/stats`, model , { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

}

export class BaseGraphQueryModel {
	dateFrom: string | null;
	dateTo: string | null;
	top: number | null;
}

export class DirectoryFilterModel extends BaseGraphQueryModel{
	directoryId: number;
}



// WEBPACK FOOTER //
// ./src/app/services/admin/admin.service.ts